<template>
  <div>
    <div class="container">
      <h3 class="text-center text-dark">Edit Your Youtube Video</h3>
      <form @submit.prevent="submit()">
        <div class="row my-5">
          <div class="col-9">
            <div class="form-group">
              <label>Youte Video Link</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter Link"
                v-model="youtube.link"
              />
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label>Youte Video Title</label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter Title"
                v-model="youtube.title"
              />
            </div>
          </div>
          <div class="my-5 mx-auto">
            <button class="btn btn-primary" type="submit">Update</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import db from "@/firebase/init.js";
export default {
  data() {
    return {
      youtube: {
        link: "",
        title: "",
        id: "",
      },
    };
  },
  methods: {
    fetchData() {
      //fetch data from fire store
      db.collection("youtube")
        .get()
        .then((res) => {
          res.forEach((item) => {
            this.youtube.link = item.data().link;
            this.youtube.title = item.data().title;
            this.youtube.id = item.id;
            console.log(item.id);
          });
        })
        .catch((err) => console.log(err));
    },
    submit() {
      db.collection("youtube")
        .doc(this.youtube.id)
        .update({ link: this.youtube.link, title: this.youtube.title })
        .then((res) => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => console.log(err));
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
